(function ($) {

	$(document).ready(function() {
        $('.review').click(function(e) {
            e.preventDefault();
            if($(this).hasClass('active')){
               $(this).removeClass('active');
            }else{
                $(this).parent('.col-grid').siblings().find('.review').removeClass('active');
                $(this).toggleClass('active');
            }
        });
        
	});
})(jQuery);